import { useSectionHistoryTop } from 'weblite-router'
import { WappOverlayPanel } from '$comp/wapp-overlay-panel'
import { OVERLAY_PANEL_Z_INDEX_FACTOR } from './components/visibility-handler'

export function WappOverlay() {
  const sectionTop = useSectionHistoryTop('overlay')
  const isTop = sectionTop === 'overlayWapp'

  return <WappOverlayPanel zIndex={isTop ? OVERLAY_PANEL_Z_INDEX_FACTOR : 0} />
}
